// extracted by mini-css-extract-plugin
module.exports = {"inactivityWindowLabel":"InactivityWindow-inactivityWindowLabel-mkCQu0"};